import { render } from "./DockerBasicImages.vue?vue&type=template&id=000d8515"
import script from "./DockerBasicImages.vue?vue&type=script&lang=js"
export * from "./DockerBasicImages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__